import MobileLabelLine from 'components/MobileWhiteCardLine'
import { DomainType } from 'features/domains/types'
import { ReclaimLicenseMobileContainer } from '../styles'
import ReviewDealerEmailCell from './ReviewDealerEmailCell'
import ReviewDealerNameCell from './ReviewDealerNameCell'

interface ReviewDealerMobileProps {
  values: Record<string, any>
  original: DomainType
}

/**
 * @todo localization
 */

function ReviewDealerMobile({ original }: ReviewDealerMobileProps) {
  return (
    <ReclaimLicenseMobileContainer>
      <ReviewDealerNameCell dealer={original} />
      <MobileLabelLine label="Phone" value={original.phone} />
      <MobileLabelLine
        label="Email"
        value={<ReviewDealerEmailCell email={original?.email} />}
      />
    </ReclaimLicenseMobileContainer>
  )
}

export default ReviewDealerMobile
